'use client';
import React from 'react';
import scrollTo from '@src/utils/scrollTo';
import { ScrollToWrapperPropsType } from './ScrollToWrapper.types';

const ScrollToWrapper: React.FC<ScrollToWrapperPropsType> = ({ children, href }) => {
  const handleClick = scrollTo({ target: href, offsetY: 140 });

  if (React.isValidElement(children)) {
    const child = children as React.ReactElement<any>; // Allow props like onClick, className, etc.

    return React.cloneElement(child, {
      ...child.props,
      onClick: handleClick,
      className:
        `${child.props.className ?? ''} text-left cursor-pointer font-normal text-primary underline hover:text-primary--v2`.trim(),
    });
  }

  // Handle plain text by wrapping in a <span>
  return (
    <span
      onClick={handleClick}
      className='text-primary hover:text-primary--v2 cursor-pointer text-left font-normal underline'
    >
      {children}
    </span>
  );
};

export default ScrollToWrapper;
